import React from 'react';
import classNames from 'classnames';
import ExploreTabWrapper from './ExploreTabWrapper';
import { Link } from 'react-router-dom';
import { FEED_EXPLORE_TAB } from 'shared/exploreConstants';
import g11n from 'hudl-g11n';

import { logTabView } from '../../utils/exploreHelpers';
import * as spt from 'shared/propTypes';
import './explore.scss';

const FormattedMessage = g11n.ReactIntl.FormattedMessage;

class ExploreTabBar extends React.Component {
  static propTypes = {
    currentTab: spt.discoveryTimeline,
    isLoggedIn: React.PropTypes.bool.isRequired,
    logData: React.PropTypes.object,
    discoveryTimelines: React.PropTypes.arrayOf(spt.discoveryTimeline).isRequired,
  }

  static defaultProps = {
    logData: {},
  }

  componentDidMount() {
    this.logTabViewIfNotFeed(this.props.currentTab);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.currentTab || !this.props.currentTab
        || nextProps.currentTab.timelineKey === this.props.currentTab.timelineKey) {
      return;
    }

    this.logTabViewIfNotFeed(nextProps.currentTab);
  }

  logTabViewIfNotFeed(tab) {
    if (!tab) {
      return;
    }

    // Skip logging tab views for the "Feed" tab.
    if (tab.timelineKey === FEED_EXPLORE_TAB) {
      return;
    }

    logTabView(tab.containerSection, this.props.logData);
  }

  renderNavItems() {
    return this.props.discoveryTimelines.map((item) => {
      const linkUrl = '/' + item.timelineKey;
      return (
        <ExploreTabWrapper key={item.timelineKey}
          isCurrentTab={(this.props.currentTab && this.props.currentTab.timelineKey === item.timelineKey)} >
            <div className="explore-tab-text">
              <Link to={linkUrl}>
                <FormattedMessage id={item.translationKey} />
              </Link>
            </div>
        </ExploreTabWrapper>
      );
    });
  }

  // Any changes made to this may need to be replicated in WebApp/Views/Shared/Explore/_NavItemLoading
  // There is some duplication there in order to have a CSHTML-based loading state.
  // Ideally we would eventually have this generated in a static way via react.
  render() {
    const classes = classNames('explore-tab-bar', {
      'logged-in': this.props.isLoggedIn,
      'logged-out': !this.props.isLoggedIn,
    });
    const navItems = this.renderNavItems();
    return (
      <div className={classes}>
        <div className="item-wrapper">
          {navItems}
        </div>
      </div>
    );
  }
}

export default ExploreTabBar;
